/* eslint-disable array-callback-return */
import React from 'react';
import CardF from '../Cards/CardF';
import "./SectionStyles/Sections.css";
import CardF1 from '../Cards/CardF1';

const SectionF = (props) => {
  const CardTheme = [
    {
      value: 2,

    }
  ];
  const cardData = [
    {
      name: 'Super Charged Twister',
      price: '250',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683894370-01.jpg&w=384&q=75',
      des: '1 Regular Pizza  + 2 Pcs Cheese Garlic Bread + 2 Drink 345ML',
      id: 1234,
    },
    {
      name: 'CardF 2',
      price: '150',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683894376-02.jpg&w=384&q=75',
      des: 'Description of CardF 2',
      id: 2345,
    },
    {
      name: 'CardF 3',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683894382-03.jpg&w=384&q=75',
      des: 'Description of CardF 3',
      id: 3456,
    },
    {
      name: 'CardF 4',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683894400-04.jpg&w=384&q=75',
      des: 'Description of CardF 3',
      id: 3456,
    },
  ];

  return (
    <>
      {CardTheme.map((theme) => {

        if (theme.value === 1) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {cardData.map((data, id) => (
                  <CardF1
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                    des={data.des}
                  />
                ))}
              </div>
            </div>
          )
        }
        else if (theme.value === 2) {
          return (
            <div id={props.id} key={theme.value}className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {cardData.map((data, id) => (
                  <CardF
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                    des={data.des}
                  />
                ))}
              </div>
            </div>
          )
        }
      }
      )
      }
    </>
  );
};
SectionF.defaultProps = {
  Heading: "Section F",
  id: "sectionF"
}
export default SectionF;
